// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"vN-z","carouselContainer":"wN-z"};